import classNames from 'classnames';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { List } from 'yoso';
import { InfiniteList } from '~/components/List/Infinite/InfiniteList';
import { CategoryType } from '~/components/Notice/Notice.hooks';
import { NoticeItem } from '~/components/Notice/NoticeItem';
import { NoticeModel, useInfiniteCategoryNotices } from '~/components/Support';
import styles from './NoticeList.module.scss';

export type NoticeListProps = {
  category: CategoryType;
  className?: string;
};
export const NoticeList = ({ category, className }: NoticeListProps) => {
  const {
    data: { pages = [] } = {},
    hasNextPage,
    isFetching,
    isFetched,
    fetchNextPage,
  } = useInfiniteCategoryNotices(category);

  const handleNextInView = useCallback(() => {
    fetchNextPage();
  }, [fetchNextPage]);

  const empty = isFetched && pages.length === 0;
  if (empty) {
    throw new Error('EMPTY');
  }

  return (
    <InfiniteList
      className={classNames(styles.root, className)}
      next={hasNextPage && !isFetching}
      onNextInView={handleNextInView}>
      {pages.map(({ documents }, i) => (
        <li key={i}>
          <List className={styles.list}>
            {documents.map((doc: NoticeModel) => (
              <li key={doc.id}>
                <Link to={`/support/notice/${doc.id}?category=${category}`}>
                  <NoticeItem {...doc} />
                </Link>
              </li>
            ))}
          </List>
        </li>
      ))}
    </InfiniteList>
  );
};
